if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.minNumberInput = document.getElementById('price-range-number-min');
      this.maxNumberInput = document.getElementById('price-range-number-max');
      this.minSliderInput = document.getElementById('price-range-slider-min');
      this.maxSliderInput = document.getElementById('price-range-slider-max');
      this.minValue = Number(this.minNumberInput.min);
      this.maxValue = Number(this.maxNumberInput.max);
      this.timeout = null;
      this.addEventListener('input', this.handleInput.bind(this));
    }

    /**
     * Handles 'input' events on the price range component.
     * @param {object} evt - Event object.
     */
    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
      }
    }

    /**
     * Updates the value of the 'number' type inputs.
     */
    updateNumberInputs() {
      this.minNumberInput.value = this.minSliderInput.value;
      this.maxNumberInput.value = this.maxSliderInput.value;
    }

    /**
     * Updates the value of the 'range' type inputs.
     * @param {object} evt - Event object.
     */
    updateSliderInputs(evt) {
      const parseOr = (value, fallback) => {
        const parsed = parseInt(value, 10);
        return Number.isNaN(parsed) ? fallback : parsed;
      };

      const movedMin = evt.target === this.minNumberInput || evt.target === this.minSliderInput;
      const movedMax = evt.target === this.maxNumberInput || evt.target === this.maxSliderInput;

      let minValue = parseOr(this.minSliderInput.value, this.minValue);
      let maxValue = parseOr(this.maxSliderInput.value, this.maxValue);

      if (evt.target === this.minNumberInput) {
        minValue = parseOr(
          this.minNumberInput.value === '' ? this.minValue : this.minNumberInput.value,
          this.minValue
        );
      } else if (evt.target === this.minSliderInput) {
        minValue = parseOr(this.minSliderInput.value, this.minValue);
      }

      if (evt.target === this.maxNumberInput) {
        maxValue = parseOr(
          this.maxNumberInput.value === '' ? this.maxValue : this.maxNumberInput.value,
          this.maxValue
        );
      } else if (evt.target === this.maxSliderInput) {
        maxValue = parseOr(this.maxSliderInput.value, this.maxValue);
      }

      minValue = Math.max(this.minValue, Math.min(minValue, this.maxValue));
      maxValue = Math.max(this.minValue, Math.min(maxValue, this.maxValue));

      if (minValue > maxValue) {
        if (movedMin) {
          maxValue = minValue;
        } else if (movedMax) {
          minValue = maxValue;
        }
      }

      this.minSliderInput.value = minValue;
      this.maxSliderInput.value = maxValue;
    }
  }

  customElements.define('price-range', PriceRange);
}
